import { render, staticRenderFns } from "./exchange-selection.vue?vue&type=template&id=57dd8ad8&scoped=true&lang=pug&"
import script from "./exchange-selection.vue?vue&type=script&lang=js&"
export * from "./exchange-selection.vue?vue&type=script&lang=js&"
import style0 from "./exchange-selection.vue?vue&type=style&index=0&id=57dd8ad8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dd8ad8",
  null
  
)

export default component.exports